import React, { useEffect, useMemo, useState } from 'react';
import MasterService from '../services/master/MasterService';

const Kemasan = ({id}) => {
    let masterService = useMemo(() => new MasterService(), [])
    const [kemasan, setKemasan] = useState('')

    useEffect(() => {
        const getKemasan = async () => {
            const response = await masterService.getKemasanById(id)
            setKemasan(response.data.uraianKemasan)
        }
        getKemasan()
    }, [masterService, id])

    return (
        <>
            {kemasan}
        </>
    )
}

export default Kemasan